import { render, staticRenderFns } from "./TeamPicker.vue?vue&type=template&id=07139338&"
import script from "./TeamPicker.vue?vue&type=script&lang=js&"
export * from "./TeamPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports